<template>
  <div class="w-full min-h-screen">
    <Navbar />
    <div
      class="px-4 lg:px-16 flex flex-col h-[80vh] overflow-y-scroll relative"
    >
      <!--<div
        :class="{
          'bg-gradient-to-t from-blue-600 to-transparent opacity-20  absolute top-0 h-[33rem] w-[calc(100%-8rem)] z-0': true,
        }"
      ></div>-->
      <div class="sticky top-0 z-10">
        <div
          class="grid grid-cols-6 text-center text-primary py-2 bg-black bg-opacity-70 backdrop-blur-sm"
        >
          <Typography class="font-semibold">Rank #</Typography>
          <Typography class="text-start font-semibold">Player</Typography>
          <Typography class="font-semibold">Logs</Typography>
          <Typography class="font-semibold">Quests</Typography>
          <Typography class="font-semibold">Streak</Typography>
          <Typography class="font-semibold">OtherPage</Typography>
        </div>
        <hr class="sticky top-10 opacity-50" />
      </div>
      <div class="flex flex-col select-none h-12"
           v-for="(player, index) in players"
           :key="player.id">
        <div
          :class="{
            'grid grid-cols-6 text-center h-12 relative': true,
            'bg-primary bg-opacity-35': auth.twitterNickName === player.user.twitter_name_id,
          }">
          <span class="h-12 flex items-center justify-center">
            <Typography
              size="main-l-num"
              :class="{
                '': true,
                'text-yellow-300': player.rank === 1,
                'text-gray-300': player.rank === 2,
                'text-primary': player.rank === 3,
                'opacity-50': player.rank > 3,
              }">{{ index + 1 }}</Typography>
          </span>
          <span class="h-12 flex items-center">
            <Typography size="main-l" class="hidden md:inline-block col-span-2 text-start">{{player.user.twitter_name_id.substring(0, 25) + (player.user.twitter_name_id.length > 25 ? '...' : '')}}</Typography>
            <Typography size="main-l" class="md:hidden col-span-2 text-start">{{player.user.twitter_name_id.substring(0, 10) + (player.user.twitter_name_id.length > 10 ? '...' : '')}}</Typography>
          </span>
          <span class="flex gap-2 items-center w-full justify-center h-12">
            <img src="~/assets/svg/troncos.svg" alt="woods" class="h-6 w-6" />
            <Typography size="main-l-num" class="">{{player.logs}}</Typography>
          </span>
          <span class="flex justify-center items-center gap-2 h-12">
            <Typography size="main-l-num" class="">{{
              player.quests
            }}</Typography>
          </span>
          <span class="flex justify-center items-center gap-2 h-12">
            <img
              src="~/assets/svg/fire_streak.svg"
              alt="fire"
              :class="{ 'h-6 w-6': true, ' opacity-0': player.streak < 3 }"
            />
            <Typography size="main-l-num" class="col-span-2 text-start">{{
              player.streak
            }}</Typography>
          </span>
          <span class="flex gap-2 items-center w-full justify-center h-12">
            <span v-if="player.user.other_page">
              <a :href="`https://other.page/u/${player.user.other_page}`" target="_blank">
                <img src="/other_page.svg" alt="Other Page" class="w-6 h-6 bg-black rounded-full" />
              </a>
            </span>
            <Typography size="main-l" class="col-span-2 text-start" v-else>-</Typography>
          </span>
          <!--
          <img
            v-if="player.rank === 10"
            src="https://cdn.freelogovectors.net/wp-content/uploads/2022/05/apecoin_logo_ape_freelogovectors.net_-400x400.png"
            class="w-6 h-6 absolute right-0 self-end m-2"
            alt=""
          />
          -->
        </div>
      </div>
    </div>
    <AlbarraModal />
    <MobileFullModal />
  </div>
</template>

<script setup>
import Typography from "@/components/common/Typography.vue";
import AlbarraModal from "../components/modals/AlbarraModal.vue";
import MobileFullModal from "../components/mobile-full-modal.vue";
import { cmsStore } from "../stores/cmsStore";
import { useAuthStore } from "../stores/useAuthStore";

const auth = useAuthStore();
const cms = cmsStore();
const players = computed(() => cms.getLeaderboard.sort((a, b) => b.logs - a.logs));

onMounted(() => {
  cms.loadLeaderboard().then();
});
const selectedPlayer = ref();
</script>
